import React, { Component } from "react"
import PropTypes from "prop-types"
import Icon from "@kit/design/icon"
import { shortName } from "./ck-timezones"

const validateDate = date => {
  var oldest_date = new Date("January 1, 1970 01:00:00")
  return date !== "Invalid Date" && !isNaN(date) && date > oldest_date
    ? true
    : false
}

const formatDate = d => {
  var date = new Date(d)
  const isValid = validateDate(date)
  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]

  if (isValid) {
    var dd = date.getDate()
    var mm = date.getMonth()
    var yyyy = date.getFullYear()

    return months[mm] + " " + dd + ", " + yyyy
  }
}

const formatTime = d => {
  var date = new Date(d)
  const isValid = validateDate(date)

  if (isValid) {
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var ampm = hours >= 12 ? "pm" : "am"
    hours = hours % 12
    hours = hours ? hours : 12
    minutes = minutes < 10 ? "0" + minutes : minutes
    var strTime = hours + ":" + minutes + ampm

    return strTime
  }
}

export class EventElement extends Component {
  static propTypes = {
    editing: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    datetime: PropTypes.string,
    timezone: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string
  }

  render() {
    const current_date = new Date()
    const date = this.props.datetime || current_date
    const defaultTimezonePlaceholder = "TZ"
    const timezone =
      this.props.timezone == null
        ? defaultTimezonePlaceholder
        : shortName(this.props.timezone)

    const classes = this.props.className || ""
    return (
      <div
        className={classes.concat(" event-date").trim()}
        onClick={this.props.onClick}
        onChange={this.props.onChange}
        onKeyPress={e => {
          if (e.key === "Enter") {
            this.props.onClick()
          }
        }}
        style={this.props.style}
        role="button"
        tabIndex="0"
      >
        <div className="event-date__date flex items-center">
          <Icon name="calendar" />
          <span>{formatDate(date)}</span>
        </div>
        <div className="event-date__date flex items-center">
          <Icon name="clock" />
          <span>
            {formatTime(date)} {timezone}
          </span>
        </div>
      </div>
    )
  }
}
